import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { ENV_ASSET_CODE, ENV_ASSET_ISSUER } from 'common/constants/env.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TCustomersListResData,
  TCustomersListReqParams,
  TUpdateCustomersReqData,
  TCreateCustomersReqData,
  TUpdateCustomersResData,
  TCreateCustomersResData,
  TCustomerAccountsListResData,
  TCustomerEntityWithMainAsset,
} from '../types/customers.types';

export const getCounterpartyCustomersListService = async (
  counterpartyGUID: string,
  params?: TCustomersListReqParams
): Promise<TCustomersListResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPARTY_CUSTOMERS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = { params };
  const res = await apiClient.get<TCustomersListResData>(url, config);

  return res.data
}

export const counterpartyGetBranchCustomersService = async (
  counterpartyGUID: string,
  branchGUID: string,
  params?: TCustomersListReqParams
): Promise<TCustomersListResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPARTY_BRANCH_CUSTOMERS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.BranchGuid, branchGUID)
  const config = {
    params,
  };
  const res = await apiClient.get<TCustomersListResData>(url, config);

  return res.data
}

export const createCustomerService = async (
  counterparty_guid: string,
  data: TCreateCustomersReqData
): Promise<TCreateCustomersResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPARTY_CUSTOMERS
    .replace(EApiPathParams.CounterpartyGuid, counterparty_guid);
  const res = await apiClient.post<TCreateCustomersResData>(url, data);

  return res.data;
};

export const updateCustomerService = async (
  counterpartyGUID: string,
  customerGUID: string,
  data: TUpdateCustomersReqData,
): Promise<TUpdateCustomersResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPART_CUSTOMER_UPDATE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.CustomerGuid, customerGUID);
  const res = await apiClient.put<TUpdateCustomersResData>(url, data);

  return res.data;
};

export const getCustomerAccountsListService = async (
  counterpartyGuid: string,
  customerGuid: string
): Promise<TCustomerAccountsListResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPARTY_CUSTOMER_ACCOUNTS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid)
    .replace(EApiPathParams.CustomerGuid, customerGuid);
  const res = await apiClient.get<TCustomerAccountsListResData>(url);

  return res.data;
};

export const getCustomersAndAccountsListService = (
  counterpartyGuid: string,
  params: TCustomersListReqParams = {}
): Promise<TCustomerEntityWithMainAsset[]> =>
  getCounterpartyCustomersListService(counterpartyGuid, params).then((data) => {
    const promises: Promise<void>[] = [];
    const result: TCustomerEntityWithMainAsset[] = [];

    if (data.customers) {
      data.customers
        .filter((customer) => customer.counterparty_guid === counterpartyGuid)
        .forEach((customer) => {
          const accountsPromise = getCustomerAccountsListService(counterpartyGuid, customer.wallet_user_guid).then(
            (customerAccountsData) => {
              if (customerAccountsData.accounts) {
                customerAccountsData.accounts.forEach((accData) => {
                  const foundAsset = accData.assets.find(
                    (asset) =>
                      asset.stellar_issuer === ENV_ASSET_ISSUER &&
                      asset.stellar_code === ENV_ASSET_CODE,
                  )!;
                  result.push({ ...customer, asset: foundAsset, accountGUID: accData.guid });
                });
              }
            },
          );
          promises.push(accountsPromise);
        });
    }

    return Promise.all(promises).then(() => result);
  });
